import { useQuery } from "@tanstack/react-query";
import { portalFeaturesApi } from "../api/portal-features.js";

export function usePortalFeatures() {
  return useQuery({
    queryKey: ["portal-features"],
    queryFn: () => portalFeaturesApi.list(),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
